// Importa estilos globais da aplicação
import './style.css'

// Importa todas as páginas da aplicação
import './pages/dashboard.page.js'     // Página principal com resumos
import './pages/transacoes.page.js'    // Página de transações
import './pages/orcamentos.page.js'    // Página de orçamentos
import './pages/relatorios.page.js'    // Página de relatórios
import './pages/configuracoes.page.js' // Página de configurações
import './pages/login.page.js'         // Página de login

// Importa componentes globais
import './components/navbar.js'         // Barra de navegação inferior
import './components/auth-guard.js'     // Proteção de rotas com navbar superior
import './components/loading-shade.js'  // Loading global

// Importa serviços globais
import { authService } from './core/services/auth.service.js'
import { startupService } from './core/services/startup.service.js'

/**
 * Mapeamento de rotas da aplicação SPA (Single Page Application)
 * Cada rota define qual componente será renderizado
 * Rotas protegidas usam auth-guard para verificar autenticação
 */
const routes = {
  '#/login': '<login-page></login-page>',  // Rota pública de login
  // Rotas protegidas com auth-guard e navbar
  '#/dashboard': '<auth-guard><dashboard-page></dashboard-page><nav-bar></nav-bar></auth-guard>',
  '#/transacoes': '<auth-guard><transacoes-page></transacoes-page><nav-bar></nav-bar></auth-guard>',
  '#/orcamento': '<auth-guard><orcamentos-page></orcamentos-page><nav-bar></nav-bar></auth-guard>',
  '#/relatorios': '<auth-guard><relatorios-page></relatorios-page><nav-bar></nav-bar></auth-guard>',
  '#/configuracoes': '<auth-guard><configuracoes-page></configuracoes-page><nav-bar></nav-bar></auth-guard>',
  '': '<auth-guard><dashboard-page></dashboard-page><nav-bar></nav-bar></auth-guard>' // Rota padrão
}

/**
 * Renderiza a rota atual baseada no hash da URL
 * Limpa loading ativo e atualiza conteúdo da aplicação
 * Chamado automaticamente em mudanças de rota (hashchange ou DOMContentLoaded)
 *
 * @sideeffect Reseta scroll para o topo da página antes de renderizar,
 * garantindo que o usuário sempre veja o início do conteúdo ao navegar
 */
export function renderRoute() {
  /** Reseta scroll para o topo ao navegar entre rotas */
  window.scrollTo(0, 0)

  const app = document.getElementById('app')
  const hash = window.location.hash
  const route = routes[hash] || routes['']  // Usa rota padrão se não encontrar
  
  // Remove loading que pode ter ficado ativo durante navegação
  const loadingShade = document.querySelector('loading-shade')
  if (loadingShade) {
    loadingShade.hide()
  }
  
  // Limpeza adicional específica para rota de login
  // Garante que loading não fique travado na tela de login
  if (hash === '#/login') {
    setTimeout(() => {
      const loadingShade = document.querySelector('loading-shade')
      if (loadingShade) {
        loadingShade.hide()
      }
    }, 0)
  }
  
  // Atualiza conteúdo da aplicação com a nova rota
  app.innerHTML = route
}

/**
 * Inicializa componente de loading global
 * Cria elemento loading-shade se não existir
 * Usado por toda a aplicação para mostrar carregamentos
 */
function initLoadingShade() {
  if (!document.querySelector('loading-shade')) {
    const loadingShade = document.createElement('loading-shade')
    document.body.appendChild(loadingShade)
  }
}

// Configura listeners para navegação SPA
window.addEventListener('hashchange', renderRoute)  // Detecta mudanças de rota
window.addEventListener('DOMContentLoaded', async () => {
  renderRoute()        // Renderiza rota inicial
  initLoadingShade()   // Inicializa loading global
  await startupService.initialize() // Inicializa caches essenciais
})

/**
 * Registra Service Worker para funcionalidades PWA
 * Permite cache offline, instalação e notificações push
 * Executado após carregamento completo da página
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('Service Worker registrado com sucesso:', registration)
      })
      .catch(registrationError => {
        console.log('Falha ao registrar Service Worker:', registrationError)
      })
  })
}

/**
 * Captura global do evento beforeinstallprompt.
 * O navegador pode disparar este evento antes do auth-guard montar.
 * Armazena em window.__deferredInstallPrompt para que o componente
 * possa verificar ao conectar e exibir o botão de instalação.
 */
window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault()
  window.__deferredInstallPrompt = event
})